/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-10-17 17:22:11
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import styles from './memorandum.module.css'
import { RootDispatch } from '../../../../app/store'
import {
  getPatientMemoDetailAsync,
  getPatientMemoSubmitAsync,
} from './memorandumSlice'

const { Option } = Select

export const AddOrEditModal = (props: {
  id?: any
  patientId?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const inputRef = useRef<any>(null)

  const dispatch = useDispatch<RootDispatch>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detail, setDetail] = useState<any>()

  const layout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 20 },
  }

  const getDetail = () => {
    dispatch(
      getPatientMemoDetailAsync({
        id: props?.id,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        form.setFieldsValue({
          ...v,
        })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      } else {
        setTimeout(() => {
          inputRef?.current?.focus()
        }, 100)
      }
    } else {
      form.resetFields()
      setDetail({})
    }
  }, [props.isModalVisible, props?.id])

  return (
    <>
      <Modal
        width={700}
        title={props?.id ? '编辑备忘信息' : '新增备忘信息'}
        visible={props.isModalVisible}
        footer={null}
        className={styles.modal}
        maskClosable={false}
        destroyOnClose={false}
        confirmLoading={confirmLoading}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(v) => {
            setConfirmLoading(true)
            dispatch(
              getPatientMemoSubmitAsync({
                ...v,
                id: props?.id,
                patientId: props?.patientId,
              })
            )
              .then(unwrapResult)
              .then((v) => {
                notification.success({
                  message: '操作成功',
                })
                props?.onOk()
              })
              .catch(() => {
                props?.onCancel()
              })
              .finally(() => {
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                {...layout}
                label='标题'
                name='title'
                rules={[{ required: true, message: '标题不能为空' }]}
              >
                <Input
                  ref={inputRef}
                  showCount
                  placeholder='请填写标题'
                  maxLength={20}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item {...layout} label='内容' name='content' rules={[{ required: true, message: '内容不能为空' }]}>
                <Input.TextArea
                  showCount
                  style={{ height: 160, resize: 'none' }}
                  placeholder='请填写内容'
                  maxLength={500}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              type='primary'
              ghost
              style={{ marginRight: '10px' }}
              onClick={() => {
                props?.onCancel()
              }}
            >
              取消
            </Button>
            <Button
              loading={confirmLoading}
              type='primary'
              onClick={() => {
                form.submit()
              }}
              style={{ marginRight: '10px' }}
            >
              确定
            </Button>
          </Row>
        </Form>
      </Modal>
    </>
  )
}
